module.exports = __webpack_public_path__ + "static/media/bandeiragrande.b4be8e0c.jpg";